import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../index.css';
import '../styles/PersonasPage.css';
import { useAuth } from '../authentication/AuthContext';

function OurPersonas() {
  const { user } = useAuth();
  const [expandedCard, setExpandedCard] = useState(null);

  const toggleCard = (index) => {
    setExpandedCard(expandedCard === index ? null : index);
  };

  const personas = [
    {
      name: "Emily",
      title: "Marketing Manager",
      age: 34,
      salary: "€85,000/year",
      image: require('../components/personas/Emily.jpg'),
      interests: ["Digital Marketing", "Yoga", "Travel Photography"],
      backstory: "With 8 years of experience in digital marketing, Emily leads campaigns for major retail brands. She's passionate about data-driven decision making and building authentic brand voices.",
      challenges: "Balancing creative innovation with ROI metrics",
      goals: ["Increase brand engagement by 25%", "Develop sustainable marketing strategies"]
    },
    {
      name: "James",
      title: "Retired School Principal",
      age: 67,
      salary: "€32,000/year (pension)",
      image: require('../components/personas/James.jpg'),
      interests: ["Gardening", "Volunteering", "Classical Music"],
      backstory: "James spent over 40 years in education, shaping the lives of thousands of students. Now retired, he volunteers at local literacy programs and enjoys spending time with his grandchildren.",
      challenges: "Staying active and engaged in the community",
      goals: ["Mentor young educators", "Travel to historical sites"]
    },
    {
      name: "Sophie",
      title: "Freelance Graphic Designer",
      age: 23,
      salary: "€28,000/year",
      image: require('../components/personas/Sophie.jpg'),
      interests: ["Illustration", "Street Art", "Indie Music"],
      backstory: "Sophie is a recent art school graduate building her freelance portfolio. She works with startups and local businesses to create unique visual identities.",
      challenges: "Finding steady clients and managing finances",
      goals: ["Land a major brand project", "Host her first solo art show"]
    },
    {
      name: "Thomas",
      title: "Factory Shift Supervisor",
      age: 51,
      salary: "€48,000/year",
      image: require('../components/personas/Thomas.jpg'),
      interests: ["Fishing", "DIY Projects", "Football"],
      backstory: "Thomas has worked in manufacturing for over 25 years, rising from line worker to supervisor. He values teamwork and safety on the job.",
      challenges: "Adapting to new automation technologies",
      goals: ["Improve team safety record", "Save for early retirement"]
    },
    {
      name: "Sarah",
      title: "University Student",
      age: 19,
      salary: "€6,000/year (part-time)",
      image: require('../components/personas/Sarah.jpg'),
      interests: ["Environmental Activism", "Photography", "Travel"],
      backstory: "Sarah is studying environmental science and works part-time at a café. She's passionate about sustainability and hopes to work for an NGO.",
      challenges: "Balancing studies, work, and activism",
      goals: ["Win a research grant", "Organize a campus sustainability event"]
    },
    {
      name: "Daniel",
      title: "Paramedic",
      age: 41,
      salary: "€39,000/year",
      image: require('../components/personas/Daniel.jpg'),
      interests: ["Mountain Biking", "Cooking", "First Aid Training"],
      backstory: "Daniel has been a paramedic for 15 years, responding to emergencies in both urban and rural areas. He also teaches first aid courses.",
      challenges: "Managing stress and long shifts",
      goals: ["Train more community members in first aid", "Complete a marathon"]
    },
    {
      name: "Laura",
      title: "Entrepreneur (Bakery Owner)",
      age: 29,
      salary: "€54,000/year",
      image: require('../components/personas/Laura.jpg'),
      interests: ["Baking", "Local Markets", "Yoga"],
      backstory: "Laura opened her own bakery after years as a pastry chef. She's focused on organic, locally sourced ingredients and community engagement.",
      challenges: "Competing with large chains",
      goals: ["Open a second location", "Develop a line of gluten-free products"]
    },
    {
      name: "Abdel",
      title: "Taxi Driver",
      age: 58,
      salary: "€31,000/year",
      image: require('../components/personas/Abdel.jpg'),
      interests: ["Chess", "World News", "Family Gatherings"],
      backstory: "Abdel immigrated 20 years ago and has been driving a taxi ever since. He enjoys meeting new people and sharing stories from his home country.",
      challenges: "Navigating city changes and ride-share competition",
      goals: ["Buy a new car", "Visit his hometown with his children"]
    },
    {
      name: "Ryan",
      title: "High School Student",
      age: 18,
      salary: "€1,200/year (odd jobs)",
      image: require('../components/personas/Ryan.jpg'),
      interests: ["Video Games", "Skateboarding", "Robotics Club"],
      backstory: "Ryan is a tech-savvy teenager who loves building robots and dreams of becoming an engineer. He does odd jobs for neighbors to save for college.",
      challenges: "Balancing schoolwork and hobbies",
      goals: ["Win a robotics competition", "Get a scholarship for university"]
    }
  ];

  return (
    <div className="account-page personas-page">
      <div className="account-container">
        <h1 className="account-title">Meet Our Personas</h1>

          <div className="intro-content">
            <p>
              Our digital participants provide thoughtful responses 
              tailored to your research needs, giving you clear, 
              actionable insights.
            </p>
            
            <p>
              With each interaction, these personas become more 
              refined and realistic, learning from our growing 
              community to deliver increasingly valuable feedback.
            </p>
          </div>

        <div className="personas-grid">
          {personas.map((persona, index) => (
            <div
              className="persona-card"
              key={index}
              onClick={() => toggleCard(index)}
            >
              <div className="persona-card-inner">
                <div className="persona-image-container">
                  <img
                    src={persona.image}
                    alt={`${persona.name}`}
                    className="persona-image"
                  />
                </div>
                <div className="persona-card-content">
                  <h3 className="persona-name">{persona.name}</h3>
                  <h4 className="persona-title">{persona.title}</h4>
                  <div className="persona-details">
                    <div className="persona-detail"><span>Age:</span> {persona.age}</div>
                    <div className="persona-detail"><span>Salary:</span> {persona.salary}</div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {expandedCard !== null && (
          <div className="modal-overlay" onClick={() => setExpandedCard(null)}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="modal-close" onClick={() => setExpandedCard(null)}>×</button>
              
              <div className="modal-header">
                <div className="modal-image-container">
                  <img
                    src={personas[expandedCard].image}
                    alt={`${personas[expandedCard].name}`}
                    className="modal-image"
                  />
                </div>
                <div className="modal-title-container">
                  <h2 className="modal-name">{personas[expandedCard].name}</h2>
                  <h3 className="modal-title">{personas[expandedCard].title}</h3>
                  <div className="modal-details">
                    <div className="modal-detail"><span>Age:</span> {personas[expandedCard].age}</div>
                    <div className="modal-detail"><span>Salary:</span> {personas[expandedCard].salary}</div>
                  </div>
                </div>
              </div>

              <div className="modal-body">
                <div className="modal-section">
                  <h4 className="modal-section-title">Interests</h4>
                  <div className="interests-list">
                    {personas[expandedCard].interests.map((interest, i) => (
                      <div key={i} className="interest-tag">{interest}</div>
                    ))}
                  </div>
                </div>

                <div className="modal-section">
                  <h4 className="modal-section-title">Background</h4>
                  <p className="modal-text">{personas[expandedCard].backstory}</p>
                </div>

                <div className="modal-section">
                  <h4 className="modal-section-title">Key Challenges</h4>
                  <p className="modal-text">{personas[expandedCard].challenges}</p>
                </div>

                <div className="modal-section">
                  <h4 className="modal-section-title">Goals</h4>
                  <ul className="goals-list">
                    {personas[expandedCard].goals.map((goal, i) => (
                      <li key={i} className="goal-item">{goal}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      
        <div className="container intro-text">
        <h1 className="account-title">What are Personas?</h1>
          <p>Personas are synthetic representations of real people created with AI to simulate authentic user feedback. They're virtual participants with consistent demographic profiles, backgrounds, preferences, and behaviors that reflect real-world population segments.</p>
        </div>
        <div className="container intro-text">
        <h1 className="account-title">How They Work</h1>
              <p>Our AI-powered personas combine demographic data with contextual information to create realistic virtual participants. Each persona has a consistent personality, background story, challenges, and goals - just like real people.</p>
        </div>
        <div className="container intro-text">
        <h1 className="account-title">How They're Used</h1>
              <p>Personas allow researchers to quickly test concepts, validate assumptions, and collect feedback without the time and expense of traditional research. They provide targeted insights that help guide product development, marketing strategies, and business decisions.</p>
        </div>
        <div className="container intro-text">
        <h1 className="account-title">In Our Research Tool</h1>
            <p>Within InstantFlows, you can select demographic filters to generate personas that match your target audience. These personas then respond to your survey questions with realistic, consistent feedback - delivering valuable insights in minutes instead of weeks.</p>
        </div>


      <div className="hero hero-3">
        <div className="outro-text">
          <h3>Unlock Rapid Consumer Insights</h3>
          <div className="container">
            <p>Our personas enable companies to quickly generate targeted insights specifically aligned to practical research use cases helping guide strategic decisions, validate assumptions, and test ideas with exceptional speed and accuracy. </p>
            <p>Whether you're testing new concepts, exploring market opportunities, or validating assumptions, our growing persona community is ready to provide valuable feedback within minutes.</p>
          </div>
          
          <div className="cta-button-container">
            {user ? (
              <Link to="/research" className="cta-button">
                Start Research Now
              </Link>
            ) : (
              <Link 
                to="/become-beta" 
                className="cta-button"
              >
                Join the Beta
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default OurPersonas;